<template>
    <v-container v-if="apiLoaded">
        <v-expansion-panels v-model="panel" :disabled="disabled" multiple>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <h2>Финансы проекта</h2>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <FinanceGraph :inputWirings="projectWInfo" :filterByGraph="filterByGraph"
                        @updateFilterByGraph="updateFilterByGraph" />
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <h2>Паспорт</h2>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <PassportTable @updateFilterByArticles="updateFilterByArticles" :filterArticles="filterByArticles"
                        :inputWirings="projectWInfo" />
                    <div style="display: flex; justify-content: flex-end; margin-top: 8px;">
                        <div
                            style="width: 350px; text-align: right; display: flex; align-items: center; justify-content: flex-end;">
                            <span><b>Прибыль (ручной расчет)</b></span>
                            <v-text-field v-model="projectCommonInfo.manualProfit" @change="manualProfitTouched = true"
                                @input="manualProfitTouched = true" type="number"
                                style="width: 100px; margin-left: 8px; margin-right: 4px; display: inline-block;"></v-text-field>
                            <span>₽</span>
                        </div>
                        <v-btn @click="saveManualProfit" :disabled="!manualProfitTouched" style="margin-left: 8px;">
                            Сохранить
                        </v-btn>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <!-- <h2>Проводки</h2> -->
                    <h2>
                        <span> Проводки </span>
                    </h2>
                </v-expansion-panel-header>
                <v-expansion-panel-content>

                    <h1>
                        <div>
                            <WiringDialog :resetKey="resetKey" @wiringSaved="reloadRegisterTab" title="Создать проводку"
                                :project="projectCommonInfo" :fromProjectFinanceTab="true">
                                <template v-slot="{ disabled, attrs, on, click }">
                                    <v-btn :disabled="disabled" :bind="attrs" :on="on" @click=click>
                                        Создать проводку</v-btn>
                                </template>
                            </WiringDialog>
                        </div>
                    </h1>
                    <WRegisterTab :fromProjectId="projectId" :inputWirings="filteredProjectWInfo" :key="resetKey" :config="config"
                        :selectMode="false" :storageKey="'wiringListHeadersProject'" />
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <div class="finance">
        </div>
    </v-container>
    <v-container v-else>
        <v-progress-linear style="width:100%" color="blue" indeterminate></v-progress-linear>
    </v-container>
</template>

<script>
import PassportTable from './Passport/PassportTable.vue';
import { projectKeyHolderNew } from '@/modules/KeysHolder';
import {
    dictToObject,
    getExpertShortName,
    loadDataToObject,
} from '@/modules/CommonUtils';
import { wiringsRegisterConfig } from '@/components/register/RegisterConfigs';
// import Register from './register/Register.vue';
import WRegisterTab from '@/components/register/WRegisterTab.vue';
import WiringDialog from '@/components/wirings/WiringDialog.vue';
import { projectStatusDict, supMarketDict } from '@/modules/NSI';
import api from '@/modules/api';
import {
    wiringTypeDirDict,
    calculatePassport,
} from '@/components/register/WireDict';
// import LettersComponent from "@/components/LettersComponent";
import { wDec, wGetAll } from '@/modules/Wirings';
import FinanceGraph from './Graph/FinanceGraph.vue'
import dayjs from 'dayjs';
import ru from 'dayjs/locale/ru';

export default {
    name: 'FinanceTab',
    components: { WRegisterTab, WiringDialog, PassportTable, FinanceGraph },
    props: ['projectCommonInfo'],
    data() {
        return {
            panel: [2],
            disabled: false,
            financeGraphShow: false,
            passportShow: false,
            encrypted: {},
            customerContracts: [],
            supplierContracts: [],
            projectWInfo: [],
            projectWenc: [],
            manualProfitTouched: false,
            filterByGraph: {},
            filterByArticles: [],
            projectStatusDict: dictToObject(projectStatusDict),
            supMarketDict: dictToObject(supMarketDict),
            projectId: null,
            projectFinance: {},
            wiringTypeDirDict: wiringTypeDirDict,
            apiLoaded: false,
            config: wiringsRegisterConfig,
            resetKey: Math.random()
        };
    },
    methods: {
        loadData: loadDataToObject,
        calculatePassport: calculatePassport,
        async reloadRegisterTab() {
            this.resetKey = Math.random();
            await this.initialize();
            this.$forceUpdate();
        },
        updateFilterByArticles(filterArticles) {
            this.filterByArticles = filterArticles;
            this.filterByGraph = {}
        },
        updateFilterByGraph(filter) {
            this.filterByGraph = filter;
            this.filterByArticles = [];

        },
        async saveManualProfit() {
            this.manualProfitTouched = false;
            const encryptedData = await projectKeyHolderNew.encode(JSON.stringify(this.projectCommonInfo));
            let req = await api.putJson('/supmain/projects/', {
                id: this.projectId,
                data: encryptedData,
                year: this.projectCommonInfo.year,
            });
            if (!req.ok) {
                alert('Ошибка сохранения данных');
            }
        },
        async initialize() {
            this.apiLoaded = false;
            if (!projectKeyHolderNew.checkKey()) return;
            this.projectId = this.$route.params?.id;

            this.projectWenc = await wGetAll();
            this.projectWInfo = await wDec(this.projectWenc);
            this.projectWInfo.sort((a, b) => b.id - a.id);
            this.projectWInfo = this.projectWInfo.filter(({ data }) => data)
            this.projectWInfo = this.projectWInfo.filter(({ data: { project } }) => project?.id == this.projectId)
            this.apiLoaded = true;
        }
    },
    computed: {
        filteredProjectWInfo() {
            return this.projectWInfo
            //return this.filterByArticles.length > 0 ? this.filteredProjectWInfoByArticles : this.filteredProjectWInfoByGraph
        },
        filteredProjectWInfoByGraph() {
            if (Object.keys(this.filterByGraph).length === 0) return this.projectWInfo
            return this.projectWInfo.filter(({ data }) => {
                let showWiring = false
                const action = data.article.action;
                const paymentDate = dayjs(data.paymentDate).locale(ru).format('MMM YY');
                const type = data.type;
                if (this.filterByGraph['итого']) {
                    const filtersArray = this.filterByGraph['итого'];
                    const filter = filtersArray.find(({ wiringType, action: wiringAction }) => (wiringType === type) && (action === wiringAction))
                    showWiring = Boolean(filter);
                }
                const filtersArray = this.filterByGraph[paymentDate];
                if (filtersArray) {
                    const filter = filtersArray.find(({ wiringType, action: wiringAction }) => (wiringType === type) && (action === wiringAction))
                    showWiring = Boolean(filter);
                }
                return showWiring;
            })
        },
        filteredProjectWInfoByArticles() {
            if (this.filterByArticles.length === 0) return []
            const articles_list = this.filterByArticles.map((field) => field.articles).reduce((acc, array) => [...acc, ...array], [])
            return this.projectWInfo.filter(({ data }) => {
                const wiringArticle = data.article.article;
                return articles_list.includes(wiringArticle);
            })
        },
        offerExpertName() {
            return getExpertShortName(
                this.offerExperts.find(
                    (e) => e?.id === this.projectCommonInfo.offerExpert
                )
            );
        },
    },
    async beforeMount() {
        await this.initialize();
    },
};
</script>
<style scoped>
.position-relative {
    position: relative;
}

.table_font {
    font-size: 11px;
    font-weight: 300;
}

.table_font td {
    font-size: small;
}

.shortName_notificator {
    font-size: smaller;
    color: #919fbc;
}

.separator_line {
    color: #919fbc;
}

.requests-list {
    display: flex;
    gap: 20px;
    flex-direction: column;
    list-style-type: none;
    padding: 0;
}

.requests-list h4 {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 140%;
    color: #3577BE;
    margin: 0 0 10px 0;
}

.requests-list li:hover h4 {
    text-decoration: underline;
}
</style>
